import { ContentEntity } from '@/types/schema';

export const ENABLED_CONTENTS: Partial<Record<NonNullable<ContentEntity['__typename']>, boolean>> =
  {
    ArticleContentType: true,
    CheckinType: true,
    CourseContentType: true,
    ExerciseType: true,
    ExternalContentType: true,
    PathContentType: true,
    QuizContentType: true,
    SurveyContentType: true,
    TaskContentType: true,
    ScormContentType: true,
    MicroLearningContentType: true,
    RoleplayContentType: true,
  };
